import { LocalitaDTO } from "./localita-dto";

export class InfoNascitaPFDTO {
	comuneNascita: string;
	provinciaNascita: string;
	//TODO
	// localitaNascita: LocalitaDTO;
	dataNascita: Date;
	nazioneNascita: string;
	isNatoEstero: boolean;
	codCatNazioneNascita: string;
}